/**
 * Tipos comuns para os processadores de questionários
 */

export type Answer = {
    valueString?: string;
    valueInteger?: number;
    valueDecimal?: number;
    valueCoding?: { code?: string; display?: string };
};

export type Item = {
    linkId: string;
    text?: string;
    answer?: Answer[];
    item?: Item[];
    answerOption?: Array<{
        valueCoding?: { code?: string; display?: string };
        extension?: Array<{ url: string; valueInteger?: number }>;
    }>;
};

export type QuestionnaireResponse = {
    id?: string;
    questionnaire?: string;
    item?: Item[];
    resourceType?: string;
    status?: string;
    authored?: string;
    subject?: {
        reference?: string;
        display?: string;
    };
    encounter?: {
        reference?: string;
    };
};

export type Questionnaire = {
    id?: string;
    url?: string;
    title?: string;
    name?: string;
    status?: string;
    description?: string;
    item?: Item[];
};

export interface BaseScoreResult {
    questionnaireId?: string;
    questionnaireResponseId?: string;
}

export function getAnswerCode(item?: Item): string | undefined {
    const coding = item?.answer?.[0]?.valueCoding;
    return coding?.code;
}

export function getAnswerNumber(item?: Item): number | undefined {
    const ans = item?.answer?.[0];
    if (!ans) return undefined;
    if (typeof ans.valueDecimal === "number") return ans.valueDecimal;
    if (typeof ans.valueInteger === "number") return ans.valueInteger;
    if (typeof ans.valueString === "string") {
        const parsed = Number(ans.valueString.replace(",", "."));
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    return undefined;
}

export function findItemByLinkId(items: Item[] | undefined, linkId: string): Item | undefined {
    return items?.find((it) => it.linkId === linkId);
}

export function isQuestionnaireOfType(questionnaire: any, typeIdentifier: string): boolean {
    if (!questionnaire) return false;

    const title = (questionnaire.title || questionnaire.name || '')?.toLowerCase?.() || '';
    const url = questionnaire.url?.toLowerCase?.() || '';

    return title.includes(typeIdentifier) || url.includes(typeIdentifier);
}
